// react-jason-schema-forms util

import { SchemaVersion } from '@/models/schema.models';
import { RJSFSchema, UiSchema } from '@rjsf/utils';
import { merge } from 'lodash';

/**
 * Merges two versioned schemas.
 * If the existing schema's major version matches the latest schema's major version,
 * it merges them; otherwise, it returns the existing schema.
 *
 * @param options - Contains existing and latest schemas with their versions.
 * @returns Merged schema with the latest version if applicable.
 */
export function mergeVersionedSchemas(options: {
  existing?: {
    version: SchemaVersion;
    schema: RJSFSchema;
    uiSchema: UiSchema;
  };
  latest: {
    version: SchemaVersion;
    schema: RJSFSchema;
    uiSchema: UiSchema;
  };
}): {
  version: SchemaVersion;
  schema: RJSFSchema;
  uiSchema: UiSchema;
} {
  const { existing, latest } = options;

  if (!existing) {
    console.log('No existing schema, using latest');
    return latest;
  }
  if (existing.version.major === latest.version.major) {
    console.log('Major version matches, merging schemas');
    return {
      version: latest.version,
      schema: merge({}, existing.schema, latest.schema),
      uiSchema: merge({}, existing.uiSchema, latest.uiSchema),
    };
  } else {
    console.log('Major version does not match, using existing schemas');
    return existing; // Return existing if major versions differ
  }
}
